module.exports = __webpack_public_path__ + "static/media/icon-dribbble.48cbf21a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon-dribbble.svg
// module id = 516
// module chunks = 0